<div class="container">

  <div id="sidebar" class="sidebar">
    <ul class="sticky">
      <li #menuItem #general class="general active" (click)="scrollTo(general)">Filtros gerais</li>
      <li #menuItem #company class="company" (click)="scrollTo(company)">Proprietários e empresas</li>
      <li #menuItem #address class="address" (click)="scrollTo(address)">Endereço padrão</li>
      <li #menuItem #neighborhood class="neighborhood" (click)="scrollTo(neighborhood)">Bairros</li>
      <li #menuItem #valueZone class="value-zone" (click)="scrollTo(valueZone)">Zonas de valor</li>
      <li #menuItem #value class="value" (click)="scrollTo(value)">Valores</li>
      <li #menuItem #feature class="feature" (click)="scrollTo(feature)">Características</li>
      <li #menuItem #date class="date" (click)="scrollTo(date)">Datas</li>
      <li #menuItem #other class="other" (click)="scrollTo(other)">Outros</li>
    </ul>
  </div>

  <div class="filters">
    <app-general-filters class="general filter"></app-general-filters>
    <app-company-filters class="company filter"></app-company-filters>
    <app-address-filters class="address filter"></app-address-filters>
    <app-neighborhood-filters class="neighborhood filter"></app-neighborhood-filters>
    <app-value-zone-filters class="value-zone filter"></app-value-zone-filters>
    <app-value-filters class="value filter"></app-value-filters>
    <app-feature-filters class="feature filter"></app-feature-filters>
    <app-date-filters class="date filter"></app-date-filters>
    <app-other-filters class="other filter"></app-other-filters>
  </div>

</div>